<script lang="ts" setup>
import type { Media } from "@/models"
import { ref } from "vue"
import { Icon } from "@/components/ui"
import { MediaType } from "@/models"

defineProps<{
  item: Media
}>()

const emit = defineEmits<{
  (e: "click", item: Media): void
}>()

const isLoading = ref<boolean>(true)
</script>

<template>
  <button data-test="gallery-item" class="relative block bg-transparent p-0 border-0 cursor-pointer w-full h-full max-h-[350px] mb-[5px] overflow-hidden" @click="emit('click', item)">
    <transition name="gpx-fade">
      <div v-if="isLoading" class="absolute inset-0 w-full h-full max-h-[350px] pointer-events-none">
        <div class="gpx-skeleton w-full min-h-[200px] h-full" />
      </div>
    </transition>
    <transition name="gpx-fade">
      <span v-if="item.type === MediaType.Vid && !isLoading" class="absolute inset-0 flex justify-center items-center z-30">
        <span class="rounded-sm p-2 bg-[var(--template-primary-colour)] text-[var(--template-secondary-colour)]"><Icon icon="Video" size="lg" /></span>
      </span>
    </transition>
    <img
      decoding="async"
      class="bg-gray-300 w-full h-full block object-cover transition-opacity duration-300 ease-in-out"
      :class="{ 'opacity-0': isLoading }"
      :src="item.getThumbnailUrl()"
      alt="Gallery Item"
      @contextmenu.prevent
      @load="isLoading = false"
      @error="isLoading = false"
    >
  </button>
</template>
